export { productSchema } from '@giffgaff/broadband-common'
